import { createSelector } from 'reselect';
import PaperFreeMonitoringPostDetailsColumns from '../../containers/PaperFreeMonitoringPostDetailsColumns';
import PaperFreeMonitoringPostDetailsTotalColumns from '../../containers/PaperFreeMonitoringPostDetailsTotalColumns';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state =>
  state.reporting.PAPER_FREE_MONITORING_POST_900_DETAILS.metadata.generatedOnDateTime;

export const getIsLoading = state =>
  state.reporting.PAPER_FREE_MONITORING_POST_900_DETAILS.isLoading;

export const getData =
  ReportDefinitions.PAPER_FREE_MONITORING_POST_900_DETAILS.getDataFunction();

export const getColumns =
  createSelector(getData, PaperFreeMonitoringPostDetailsColumns);

export const getTotalColumns =
  createSelector(getData, PaperFreeMonitoringPostDetailsTotalColumns);
